import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useLocation, Link as RouterLink } from "react-router-dom";

const DynamicBreadcrumbs = () => {
  const location = useLocation(); // Get the current route path
  const pathnames = location.pathname.split("/").filter((x) => x); // Split path into segments

  return (
    <Breadcrumbs aria-label="breadcrumb">
      {/* Always include the "Home" link */}
      <Link underline="hover" color="inherit" component={RouterLink} to="/">
        Home
      </Link>

      {/* Generate breadcrumbs dynamically */}
      {pathnames.map((value, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`; // Build the route for the breadcrumb
        const isLast = index === pathnames.length - 1; // Check if this is the last breadcrumb

        return isLast ? (
          // Last breadcrumb is plain text
          <Typography
            key={value}
            color="text.primary"
            className="breadcrumb-link"
            sx={{ color: "rgba(83, 13, 128, 1)", fontWeight:'700', textTransform: 'capitalize' }}
          >
            {decodeURIComponent(value.replace(/-/g, " "))} {/* Convert path segment to readable format */}
          </Typography>
        ) : (
          // Intermediate breadcrumbs are clickable links
          <Link
            key={value}
            underline="hover"
            color="inherit"
            component={RouterLink}
            to={routeTo}
          >
            {decodeURIComponent(value.replace(/-/g, " "))} {/* Convert path segment to readable format */}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default DynamicBreadcrumbs;
